import React, { Component } from 'react';
import Datatable from '../../common/datatable';
import store, { history } from '../../../store';
import { connect } from 'react-redux';

class OutletTable extends Component {
    render() {
        const columns = [
            { prop: 'customer-number', title: 'Customer Number', width: '150' },
            { prop: 'name', title: 'Outlet Name' },
            { prop: 'staff-count', title: '# Staff', width: '70' },
        ];

        const actions = [
            {
              label: 'View',
              permissions: {
                action: 'manage',
                subjectClass: 'Outlet'
              },
              callback: (row) => {
                history.push(`/admin/outlets/${row.id}/view`);
            }},
            {
              label: 'Delink',
              color: 'grey',
              permissions: {
                action: 'delink',
                subjectClass: 'Outlet'
              },
              render:(cell, row)=>{
                return row.attributes.linked;
              },
              callback: (row) => {
                history.push(`/admin/outlets/${row.id}/delink`);
            }}
        ];

        return (
            <div>
                <Datatable
                    data={this.props.outlets}
                    dataSize={this.props.paging.number * this.props.paging.size}
                    columns={columns}
                    actions={actions}
                    hideId={false}
                    pagination={{
                        page: this.props.currentPage,
                        sizePerPage: 20,
                        onPageChange: this.props.onPageChange,
                    }}
                    remote
                />
            </div>
        )
    }
}

export default connect()(OutletTable);



// WEBPACK FOOTER //
// ./src/components/admin/outlet-list/outlet-table.jsx